__turbopack_context__.v({
  "circle": "index-module-scss-module__5sq7Cq__circle",
  "rotate": "index-module-scss-module__5sq7Cq__rotate",
});
